<button *ngIf="!checking" mat-raised-button color="primary" (click)="checkClashes()">Check Conflicts</button>
<mat-spiiner *ngIf="checking"></mat-spiiner>
